<template>
    <div class="carousel-arrow-nav">
        <div class="carousel-arrow-nav--arrow"
                v-for="(arrow, arrowIdx) in arrowNav" :key="arrow"
                :class="[bemAdd(arrow.dir, 'arrow')]">
            <button type="button"
                    class="carousel-arrow-nav--button btn btn__bubble btn__overlay btn__large"
                    :disabled="isArrowDisabled[arrow.dir] ? true : null"
                    @click.prevent="changeHandler(activeIdx + arrow.change)">
                <cmp-ink-ripple></cmp-ink-ripple>
                <cmp-icon class="btn--bubble-icon" :symbol="arrow.icon" size="small"></cmp-icon>
            </button>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';


    export default {
        mixins: [
            bemMixin('carousel-arrow-nav'),
        ],
        props: {
            numItems: {
                type: Number,
                required: true,
            },
            activeIdx: {
                type: Number,
                required: true,
            },
            changeHandler: {
                type: Function,
                required: true,
            },
        },
        data() {
            return {
                arrowNav: [
                    {
                        dir: 'prev',
                        change: -1,
                        icon: 'arrow-left',
                    },
                    {
                        dir: 'next',
                        change: 1,
                        icon: 'arrow-right',
                    },
                ],
            };
        },
        computed: {
            isArrowDisabled() {
                return {
                    prev: (this.activeIdx <= 0),
                    next: (this.activeIdx >= this.numItems - 1),
                };
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/ui/carousel/carousel-arrow-nav/index.vue?11a3cbc1